// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/ricarica/colonnine/:id',
    requestBody: null,
    response: '{success:true,data:{gateway:{raggiungibile,ultimoContattoAt},colonnina:{id,societaId,societaNome,nome,codiceOcpp,sede,marca,modello,seriale,firmware,collegata,ultimoContattoAt,stato,codiceErrore,attiva,passwordImpostata,connettori}}}'
  },
  {
    method: 'GET',
    endpoint: '/api/ricarica/colonnine/:id/comandi',
    requestBody: null,
    response: '{success:true,data:[{id,tipo,parametri,stato,risposta,messaggio,richiestoDa,createdAt,esitoAt}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/ricarica/tariffe?societaId',
    requestBody: null,
    response: '{success:true,data:[{id,prezzoKwh,validaDal,creatoDa}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/ricarica/colonnine/:id/comandi',
    requestBody: '{tipo,parametri}',
    response: '{success:true,data:{id}}'
  },
  {
    method: 'GET',
    endpoint: '/api/ricarica/colonnine/:id/badge-avvio',
    requestBody: null,
    response: '{success:true,data:[{codice,dipendente}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/ricarica/colonnine/:id/password',
    requestBody: null,
    response: '{success:true,data:{password}}'
  },
  {
    method: 'GET',
    endpoint: '/api/ricarica/sedi?societaId',
    requestBody: null,
    response: '{success:true,data:[{id,nome}]}'
  },
  {
    method: 'PUT',
    endpoint: '/api/ricarica/colonnine/:id',
    requestBody: '{nome,sedeId,attiva}',
    response: '{success:true}'
  },
  {
    method: 'POST',
    endpoint: '/api/ricarica/tariffe',
    requestBody: '{societaId,prezzoKwh,validaDal}',
    response: '{success:true,data:{id}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/ricarica/tariffe/:id',
    requestBody: null,
    response: '{success:true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
